import {
  CountryApiEnum,
  FormStatusApiEnum,
  GuestPictureTypeApiEnum,
  IdTypeApiEnum,
  type ListingPublicPropertiesApiDto,
  type PublicFormDataApiDto,
} from "@/types/api";
import { Gender } from "@/types/enums";
import type { FormGuestEntry } from "@/types/guest";

export const PREVIEW_LISTING_ID = "preview-listing-id";
export const PREVIEW_FORM_ID = "preview-form-id";
export const PREVIEW_MAIN_GUEST_ENTRY_ID = "preview-main-guest-entry";

// WHY hardcoded fixtures: the preview routes deliberately do not fetch — they render
// real components against deterministic sample data so the iframe shows the live
// effect of the dashboard's in-progress brand state. Field shapes mirror the public
// DTOs the components consume so the preview surface and the production surface
// stay structurally identical.
export const PREVIEW_LISTING: ListingPublicPropertiesApiDto = {
  title: "Casa del Mar",
  defaultCheckinTime: "15:00",
  defaultCheckoutTime: "11:00",
  maxPeople: 4,
};

// WHY in-future dates: BookingDetails and the FormPage InfoBanner format these for
// display; using today+1 / today+5 makes the preview look realistic regardless of
// when the owner opens it. Computed at module load so a long-lived preview iframe
// session still shows sensible dates.
const today = new Date();
const tomorrow = new Date(today);
tomorrow.setDate(today.getDate() + 1);
const fiveDaysOut = new Date(today);
fiveDaysOut.setDate(today.getDate() + 5);
const sampleCheckIn = `${tomorrow.toISOString().slice(0, 10)}T15:00:00`;
const sampleCheckOut = `${fiveDaysOut.toISOString().slice(0, 10)}T11:00:00`;

export const PREVIEW_FORM: PublicFormDataApiDto = {
  templateId: "preview-template",
  listingTitle: PREVIEW_LISTING.title,
  listingAddress: "Av. del Mar 1234",
  listingCity: "Manta",
  listingCountry: "Ecuador",
  checkInDate: sampleCheckIn,
  checkOutDate: sampleCheckOut,
  numberOfGuests: 2,
  maxVehicles: 1,
  allowPets: true,
  status: FormStatusApiEnum.SENT,
  latitude: -0.9676533,
  longitude: -80.7089101,
  requiredGuestImages: [
    GuestPictureTypeApiEnum.ID_FRONT,
    GuestPictureTypeApiEnum.SELFIE,
  ],
  requiredBookingContract: false,
  signedContract: false,
  minAgeToRequireImages: 18,
  requireContactDataFromAllGuests: false,
  overallProgress: 50,
  contractStatus: undefined,
  rejectionReason: undefined,
  formMessages: {},
  brandSlug: null,
  brandAutoRedirect: true,
  // Story 42-15: the preview never uploads, so the ID photo check is off.
  idScanEnabled: false,
  version: "preview-v1",
  data: {
    mainGuest: {
      guestNumId: 1,
      firstName: "Mirable",
      middleName: "",
      lastName: "Claranta",
      gender: Gender.FEMALE,
      idType: IdTypeApiEnum.PASSPORT,
      id: "P1234567",
      idIssuingCountry: CountryApiEnum.ECUADOR,
      telephoneNumber: "+593900000000",
      email: "guest@example.com",
      birthDate: "1992-04-12",
      acceptTerms: true,
      acceptPrivacy: true,
      consentDataStorage: true,
      consentMarketing: false,
      files: [],
      progress: 100,
    },
    otherGuests: [],
    vehicles: [],
    pets: [],
  },
};

export const PREVIEW_GUEST_ENTRIES: FormGuestEntry[] = [
  {
    id: PREVIEW_MAIN_GUEST_ENTRY_ID,
    formId: PREVIEW_FORM_ID,
    guestNumId: 1,
    isMainGuest: true,
    complianceStatus: "COMPLETED",
    firstName: "Mirable",
    lastName: "Claranta",
    gender: "FEMALE",
    idType: "PASSPORT",
    idNumber: "P1234567",
    idIssuingCountry: "ECUADOR",
    nationality: "ECUADOR",
    dateOfBirth: "1992-04-12",
    email: "guest@example.com",
    phone: "+593900000000",
    createdAt: new Date(today.getTime() - 60 * 60 * 1000).toISOString(),
  },
];
